<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-header>
                <span class="h5">CONTRATOS</span>
            </b-card-header>
            <b-card-body>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <app-tabela
                    idTabela="tblContratos"
                    :itens="contratosFiltrados"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <b-row class="mt-2">
                            <b-col sm="12">
                                <div class="float-right">
                                    <b-form-checkbox
                                        v-model="apenasContratosAtivos"
                                        :value="true"
                                        :unchecked-value="false"
                                        ><strong>
                                            APENAS CONTRATOS ATIVOS</strong
                                        >
                                    </b-form-checkbox>
                                </div>
                            </b-col>
                        </b-row>
                    </template>
                    <template slot="valorTotal" slot-scope="data">{{
                        data.valorTotal | currency
                    }}</template>
                    <template slot="saldo" slot-scope="data">{{
                        data.saldo | currency
                    }}</template>
                    <template slot="acoes" slot-scope="data">
                        <span class="text-primary">
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="detalharContrato(data)"
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view
            :contratos="contratos"
            :dataServico="dataServico"
        ></router-view>
    </div>
</template>

<script>
export default {
    props: {
        fornecedorId: {
            type: String,
            default: () => null
        },

        dataServico: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            apenasContratosAtivos: true,
            erros: [],
            contratos: [],
            contrato: {},
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'codContrato',
                    label: 'Código',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'objeto',
                    label: 'Objeto do Contrato',
                    filterable: true
                },
                {
                    key: 'inicioVigencia',
                    label: 'Início da Vigência',
                    sortable: true,
                    type: 'date'
                },
                {
                    key: 'fimVigencia',
                    label: 'Fim da Vigência',
                    sortable: true,
                    type: 'date'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    tdClass: 'text-nowrap text-right'
                },
                // {
                //     key: 'saldo',
                //     label: 'Saldo',
                //     tdClass: 'text-nowrap text-right'
                // },
                {
                    key: 'gestor',
                    label: 'Gestor',
                    filterable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                    filterable: true,
                    type: 'status'
                }
            ],
            itensPorPagina: 10
        }
    },
    methods: {
        obterContratos() {
            this.$store.dispatch('addRequest')
            this.dataServico.obterContratos(this.$store.getters.isFornecedor)
            .then((response) => {
                if (response) {
                    if (response.success) {
                        this.contratos = response.data
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            .catch(error => {
                this.$store.dispatch('removeRequest')
                this.$toast.error(
                    'Não foi possível obter os contratos',
                    'Erro',
                    this.$toastConfig.error
                )
            })
        },

        detalharContrato(contrato) {
            let nextRoute = 'FornecedorContratos_Detalhar'
            if (this.$route.name === 'FornecedoresContratos') {
                nextRoute = 'FornecedoresContratos_Detalhar'
            }
            this.$router.push({
                name: nextRoute,
                params: {
                    codContrato: contrato.codContrato.replaceAll('/', '-')
                }
            })
        }

        // obterDataServicos() {
        //     if (
        //         this.$route.name === 'FornecedoresContratos_Detalhar' ||
        //         this.$route.name === 'FornecedoresContratos_Requisicoes' ||
        //         this.$route.name === 'FornecedoresContratos_RequisicaoDetalhar'
        //     ) {
        //         return this.dataServico
        //     } else {
        //         return ContratosServicos
        //     }
        // }
    },

    created() {
        this.obterContratos()
    },

    computed: {
        mostrarTabela() {
            return (
                this.$route.name === 'FornecedorContratos' ||
                this.$route.name === 'FornecedoresContratos'
            )
        },

        contratosFiltrados() {
            if (this.apenasContratosAtivos) {
                return [
                    ...this.contratos.filter((contrato) => {
                        return contrato.status != 'VENCIDO'
                    })
                ]
            }
            return [...this.contratos]
        }
    },

    watch: {},

    components: {}
}
</script>
